import clsx from 'clsx';
import { Text } from './text';
import { Pagination } from './pagination';
import { Spinner } from './spinner';

export enum TablePaginationCountOfItems {
  Five = 5,
  Ten = 10,
  Twenty = 20,
  Thirty = 30,
}

export enum TableCellType {
  Text,
  Custom,
}

interface ITableProps {
  columns: string[];
  items: { type: TableCellType; value: any }[][];
  onClick?: (rowIndex: number) => void;
  pagination?: {
    currentPage: number;
    totalItemCount: number;
    countItemPage: TablePaginationCountOfItems;
    onChangePage: (pageNumber: number) => void;
    onChangeCountItemPage: (pageNumber: number) => void;
  };
  isScrollable?: boolean;
  isLoading?: boolean;
}
export const Table = (props: ITableProps) => {
  return (
    <div className='flex flex-col w-full'>
      <div className={clsx('flex w-full bg-white dark:bg-soft-black px-7', props.isScrollable && 'overflow-x-auto')}>
        <table className='w-full text-sm'>
          <thead className='text-slate dark:text-white opacity-40 dark:opacity-50 text-xs font-semibold uppercase'>
            <tr>
              {props.columns.map((x, key) => (
                <th key={key} scope='col' className='text-left py-4 px-2'>
                  {x}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.isLoading && (
              <tr>
                <td colSpan={props.columns.length} className='py-4 overflow-hidden'>
                  <Spinner />
                </td>
              </tr>
            )}
            {!props.isLoading && props.items.length > 0 && (
              <>
                {props.items.map((rowItem, key) => (
                  <tr
                    key={key}
                    className={clsx('px-7', props.onClick && 'cursor-pointer', props.items.length - 1 != key && 'border-b border-b-gray-black')}
                    onClick={() => props.onClick?.(key)}
                  >
                    {rowItem.map((cell, key2) => {
                      let cellResult = undefined;
                      if (cell.type == TableCellType.Text)
                        cellResult = (
                          <Text className='text-nowrap' size='sm'>
                            {cell.value}
                          </Text>
                        );
                      else cellResult = cell.value;
                      return (
                        <th key={key2} scope='row' className={clsx('text-left py-4', key2 != 0 && 'px-2')}>
                          {cellResult}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </>
            )}
            {!props.isLoading && props.items.length <= 0 && (
              <tr>
                <td colSpan={props.columns.length} className='text-center py-4'>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {props.pagination && <Pagination className='mt-6' {...props.pagination} />}
    </div>
  );
};
